import { render, staticRenderFns } from "./ProfeeTables.vue?vue&type=template&id=fc4bc92a&scoped=true&"
import script from "./ProfeeTables.vue?vue&type=script&lang=js&"
export * from "./ProfeeTables.vue?vue&type=script&lang=js&"
import style0 from "./ProfeeTables.vue?vue&type=style&index=0&id=fc4bc92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4bc92a",
  null
  
)

export default component.exports